var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkMarkSize } from 'uitk-react-mark';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import { UitkUnformattedHtml } from 'uitk-react-unformatted-html';
import { IconMark } from '../../../../../common/icon-mark';
export var ActivityFeature = function (_a) {
  var label = _a.label,
    a11yLabel = _a.a11yLabel,
    icon = _a.icon,
    mark = _a.mark,
    isLoyaltyEarnDisplay = _a.isLoyaltyEarnDisplay,
    className = _a.className,
    extraProps = __rest(_a, ["label", "a11yLabel", "icon", "mark", "isLoyaltyEarnDisplay", "className"]);
  return React.createElement(UitkLayoutFlex, __assign({
    alignItems: "center"
  }, extraProps, {
    className: className
  }), (icon || mark) && !isLoyaltyEarnDisplay && React.createElement(UitkSpacing, {
    margin: {
      inlineend: 'one'
    }
  }, React.createElement(IconMark, {
    icon: icon,
    mark: mark,
    defaultIconSize: UitkIconSize.EXTRA_SMALL,
    markSize: UitkMarkSize.EXTRA_SMALL
  })), ((mark === null || mark === void 0 ? void 0 : mark.url) || (mark === null || mark === void 0 ? void 0 : mark.id)) && isLoyaltyEarnDisplay && React.createElement(UitkSpacing, {
    margin: {
      inlineend: 'two'
    }
  }, React.createElement(IconMark, {
    mark: mark,
    markSize: UitkMarkSize.SMALL
  })), React.createElement("span", null, a11yLabel && React.createElement("span", {
    className: "is-visually-hidden"
  }, a11yLabel), !isLoyaltyEarnDisplay && React.createElement("span", {
    "aria-hidden": Boolean(a11yLabel)
  }, label), isLoyaltyEarnDisplay && React.createElement("span", {
    "aria-hidden": Boolean(a11yLabel)
  }, React.createElement(UitkText, {
    align: "left",
    theme: "loyalty"
  }, React.createElement(UitkUnformattedHtml, {
    htmlToParse: label
  })))));
};